import { createSlice } from '@reduxjs/toolkit'
import {
  REDUX_STATUS_FAILED,
  REDUX_STATUS_IDLE,
  REDUX_STATUS_LOADING,
  REDUX_STATUS_SUCCESS,
} from 'src/consumer/constants'
import { resetStores } from 'src/store'
import { getScreeningReportTemplateData } from './services/screeningReportTemplate'

const initialState = {
  screeningReportTemplate: {
    data: null,
    status: REDUX_STATUS_IDLE,
    error: null,
  },
}

const screeningReportSlice = createSlice({
  name: 'screeningReportTemplateStore',
  initialState,
  // reducers: {
  //   setProfileData(state, action) {
  //     return {
  //       ...state,
  //       profileData: {
  //         data: action.payload,
  //         status: REDUX_STATUS_SUCCESS,
  //         error: null,
  //       },
  //     }
  //   },
  // },
  extraReducers: (builder) => {
    builder
      .addCase(getScreeningReportTemplateData.pending, (state) => {
        state.screeningReportTemplate.status = REDUX_STATUS_LOADING
      })
      .addCase(getScreeningReportTemplateData.fulfilled, (state, action) => {
        state.screeningReportTemplate.status = REDUX_STATUS_SUCCESS
        state.screeningReportTemplate.data = action.payload
      })
      .addCase(getScreeningReportTemplateData.rejected, (state, action) => {
        state.screeningReportTemplate.status = REDUX_STATUS_FAILED
        state.screeningReportTemplate.error = action.payload
      })
    .addCase(resetStores, () => initialState)
  },
})

export const screeningReportTemplateDataReducer = screeningReportSlice.reducer

export const selectScreeningReportTemplateData = (state) => {
  return state?.screeningReportTemplateStore?.screeningReportTemplate
}
